<template>
  <div class="flex justify-center items-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-2xl">
      <h1 class="mb-8 text-3xl font-bold">
        <span class="font-medium text-white">Reset Password</span>
      </h1>

      <div class="overflow-hidden max-w-3xl bg-white rounded-md shadow">
        <form @submit.prevent="submitResetPassword">
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <text-input
              v-model="form.email"
              :error="form.errors.email"
              class="pr-6 pb-8 w-full lg:w-1/2"
              label="Email"
              disabled />
          </div>
          <div class="flex flex-wrap p-8 -mr-6 -mb-8">
            <text-input
              v-model="form.password"
              :error="form.errors.password"
              class="pr-6 pb-8 w-full lg:w-1/2"
              type="password"
              autocomplete="new-password"
              label="Password" />
            <text-input
              v-model="form.password_confirmation"
              :error="form.errors.password_confirmation"
              class="pr-6 pb-8 w-full lg:w-1/2"
              type="password"
              autocomplete="confirm-password"
              label="Confirm Password" />
          </div>
          <div class="flex flex-wrap justify-end items-center py-4 px-8 bg-gray-50 border-t border-gray-100">
            <div>
              <loading-button
                :loading="form.processing"
                class="btn-indigo"
                type="submit">
                Update Password
              </loading-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Forgot Password' },
  components: {
    LoadingButton,
    TextInput,
  },
  remember: 'form',
  props: {
    email: String,
    token: String,
    status: String,
  },
  data () {
    return {
      form: this.$inertia.form({
        token: this.token,
        email: this.email,
        password: '',
        password_confirmation: '',
      }),
    }
  },
  methods: {
    submitResetPassword () {
      this.form.post(this.route('password.update'), {
        onFinish: () => this.form.reset('password', 'password_confirmation'),
      })
    },
  },
}
</script>
